import kuromoji from 'kuromoji';
import { WordResult } from './WordPopup';

export const isJapanese = (text: string): boolean =>
  /[぀-ヿ一-鿿]/.test(text);

const SKIP_PREFETCH_POS = new Set(['助詞', '記号', '空白']);

export const wordFromToken = (token: kuromoji.IpadicFeatures): string => {
  const isInflected = token.pos === '動詞' || token.pos === '形容詞';
  return (isInflected && token.basic_form && token.basic_form !== '*')
    ? token.basic_form
    : token.surface_form;
};

export const fetchWord = async (word: string): Promise<WordResult | null> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const res = await fetch('https://jotoba.de/api/search/words', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: word, language: 'English', no_english: false }),
      signal: controller.signal,
    });
    const data = await res.json();
    const first = data?.words?.[0];
    if (!first) return null;
    return {
      reading: first.reading?.kana ?? '',
      definition: first.senses?.[0]?.glosses?.[0] ?? 'No definition found',
    };
  } finally {
    clearTimeout(timeout);
  }
};

export const prefetchDefinitions = (
  tokens: kuromoji.IpadicFeatures[],
  cache: Map<string, WordResult | null>,
) => {
  const words = Array.from(new Set(
    tokens.filter(t => !SKIP_PREFETCH_POS.has(t.pos)).map(wordFromToken)
  )).filter(w => !cache.has(w));

  if (words.length === 0) return;

  let idx = 0;
  const next = async () => {
    while (idx < words.length) {
      const word = words[idx++];
      let result: WordResult | null = null;
      try { result = await fetchWord(word); } catch {}
      cache.set(word, result);
    }
  };
  for (let i = 0; i < Math.min(3, words.length); i++) next();
};
